import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ecs_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error?.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = localStorage.getItem("ecs_refresh_token");
      if (refresh) {
        try {
          const r = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refresh });
          localStorage.setItem("ecs_access_token", r.data.access_token);
          original.headers.Authorization = `Bearer ${r.data.access_token}`;
          return api(original);
        } catch (_) {
          localStorage.removeItem("ecs_access_token");
          localStorage.removeItem("ecs_refresh_token");
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
